import styled from 'styled-components';

export const Card = styled.div`
  background: linear-gradient(
    90deg,
    ${(props) => props.theme.$primary_light} 0%,
    ${(props) => props.theme.$bg_green} 100%
  );
  border: 1px solid ${(props) => props.theme.$green_orchid};
  border-radius: 8px;

  .summary-icon {
    width: 20px;
    height: 20px;
  }

  .summary-title {
    font-size: 16px;
    color: ${(props) => props.theme.$dark};
  }

  .summary-text {
    font-size: 14px;
    line-height: 1.5;
    color: ${(props) => props.theme.$gray700};
    white-space: pre-line;

    &.is-clamped {
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;

      &.is-inline {
        -webkit-line-clamp: 2;
      }
    }
  }

  .badge {
    font-size: 12px;
    font-weight: 600;
    padding: 4px 8px;
  }
`;
